import React from 'react';
import { Box, Button, ButtonProps, ButtonGroup, Image } from '@chakra-ui/core';
import { observer } from 'mobx-react';
import useHandleResponse from './useHandleResponse';
import { selectedButtonVariant } from '../helpers';

const gifs: Record<string, string> = {
  One: 'https://media.giphy.com/media/8y83duxEmR0oU/giphy.gif',
  Two: 'https://media.giphy.com/media/OxeCmRsZsXSCI/giphy.gif',
  Three: 'https://media.giphy.com/media/FHzemFzwkyRfq/giphy.gif',
};

const StyledButton: React.FC<ButtonProps> = (props) => (
  <Button
    type="button"
    colorScheme="blue"
    fontSize="3xl"
    width="100px"
    height="auto"
    {...props}
  />
);

const Range: React.FC = () => {
  const { response, handleResponse } = useHandleResponse();
  const value = response && response.data.value;

  return (
    <Box textAlign="center">
      <ButtonGroup
        display="inline-flex"
        spacing={8}
        alignItems="stretch"
        height="64px"
        mx="auto"
        my={8}
      >
        <StyledButton
          variant={selectedButtonVariant(value, 'One')}
          onClick={handleResponse('One')}
        >
          1
        </StyledButton>
        <StyledButton
          variant={selectedButtonVariant(value, 'Two')}
          onClick={handleResponse('Two')}
        >
          2
        </StyledButton>
        <StyledButton
          variant={selectedButtonVariant(value, 'Three')}
          onClick={handleResponse('Three')}
        >
          3
        </StyledButton>
      </ButtonGroup>

      {value && (
        <Box textAlign="center" mt={8}>
          <Image src={gifs[value]} alt={value} mx="auto" ignoreFallback />
        </Box>
      )}
    </Box>
  );
};

export default observer(Range);
